// extracted by mini-css-extract-plugin
export default {"responsiveBackground":"awjd3O"};